/* tslint:disable */

declare var Object: any;
export interface ERPpurchasePrepaymentSettlementInterface {
  "id"?: number;
}

export class ERPpurchasePrepaymentSettlement implements ERPpurchasePrepaymentSettlementInterface {
  "id": number;
  constructor(data?: ERPpurchasePrepaymentSettlementInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPpurchasePrepaymentSettlement`.
   */
  public static getModelName() {
    return "ERPpurchasePrepaymentSettlement";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPpurchasePrepaymentSettlement for dynamic purposes.
  **/
  public static factory(data: ERPpurchasePrepaymentSettlementInterface): ERPpurchasePrepaymentSettlement{
    return new ERPpurchasePrepaymentSettlement(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPpurchasePrepaymentSettlement',
      plural: 'ERPpurchasePrepaymentSettlements',
      path: 'ERPpurchasePrepaymentSettlements',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPpurchasePrepaymentSettlement.ts